import { useBreakpointValue } from '@chakra-ui/react';

import { Flex } from 'src/components/UI/Flex';
import DoctorAvatarIcon from 'src/components/Icons/DoctorAvatarIcon';
import Typography from 'src/components/Typography';

import { getFirstAndLastWords } from 'src/helpers/getFirstAndLastWords';
import { HeaderSkeleton } from '../skeletons/HeaderSkeleton';
import { useAssistantContext } from 'src/providers/AssistantProvider';

export function Header() {
  const { assistantData } = useAssistantContext();

  const currentBreakpoint = useBreakpointValue(
    {
      base: 'base',
      sm: 'sm',
      md: 'md',
    },
    {
      ssr: false,
    }
  );

  if (!assistantData) {
    return <HeaderSkeleton />;
  }

  const doctorAvatarIconSize = currentBreakpoint === 'base' ? 124 : 50;
  const prescriberName =
    currentBreakpoint === 'md' ? assistantData?.fullName : getFirstAndLastWords(assistantData?.fullName ?? '');

  return (
    <Flex
      gap={'30px'}
      mt={'28px'}
      alignItems={'center'}
      flexDirection={{
        base: 'column',
        sm: 'row',
      }}
    >
      <DoctorAvatarIcon width={doctorAvatarIconSize} />

      <Typography model={'h1'} fontSize={30} textAlign="center">
        {prescriberName}
      </Typography>
    </Flex>
  );
}
